const ROLE_CITIZEN = "citizen"
const ROLE_CITY = "city"
const ROLE_PARTNER = "partner"
const ROLE_SPALLIAN = "spallian"

const ROLE_SUPER_ADMIN_CONSTANT = "ROLE_SUPER_ADMIN"
const ROLE_ADMIN_CONSTANT = "ROLE_ADMIN"
const ROLE_MODERATOR_AND_HANDLER_CONSTANT = "ROLE_MODERATOR_AND_HANDLER"
const ROLE_COMMUNICATION_CONSTANT = "ROLE_COMMUNICATION"
const ROLE_SUPERVISOR_CONSTANT = "ROLE_SUPERVISOR"
const ROLE_USER_CONSTANT = "ROLE_USER"
const ROLE_ENGAGED_PARTNER_CONSTANT = "ROLE_ENGAGED_PARTNER"
const ROLE_PREMIUM_PARTNER_CONSTANT = "ROLE_PREMIUM_PARTNER"
const ROLE_SPALLIAN_CONSTANT = "ROLE_SPALLIAN"

const ROLE_SUPER_ADMIN_LABEL = "Super administrateur"
const ROLE_ADMIN_LABEL = "Administrateur"
const ROLE_MODERATOR_AND_HANDLER_LABEL = "Modérateur / Personne à charge"
const ROLE_COMMUNICATION_LABEL = "Communication"
const ROLE_SUPERVISOR_LABEL = "Superviseur"
const ROLE_USER_LABEL = "Utilisateur"
const ROLE_SPALLIAN_LABEL = "Spallian"
const ROLE_ENGAGED_PARTNER_LABEL = ""
const ROLE_PREMIUM_PARTNER_LABEL = ""

export {
    ROLE_CITIZEN,
    ROLE_CITY,
    ROLE_PARTNER,
    ROLE_SPALLIAN,

    ROLE_SUPER_ADMIN_CONSTANT,
    ROLE_ADMIN_CONSTANT,
    ROLE_MODERATOR_AND_HANDLER_CONSTANT,
    ROLE_COMMUNICATION_CONSTANT,
    ROLE_SUPERVISOR_CONSTANT,
    ROLE_USER_CONSTANT,
    ROLE_ENGAGED_PARTNER_CONSTANT,
    ROLE_PREMIUM_PARTNER_CONSTANT,
    ROLE_SPALLIAN_CONSTANT,

    ROLE_SUPER_ADMIN_LABEL,
    ROLE_ADMIN_LABEL,
    ROLE_MODERATOR_AND_HANDLER_LABEL,
    ROLE_COMMUNICATION_LABEL,
    ROLE_SUPERVISOR_LABEL,
    ROLE_USER_LABEL,
    ROLE_ENGAGED_PARTNER_LABEL,
    ROLE_PREMIUM_PARTNER_LABEL,
    ROLE_SPALLIAN_LABEL
}